"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = sortable;
exports.sortablePropTypes = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * A function that returns a React HOC that provides a sort function the wrapped component.
 * Given a `sortPath`, this function will compare the values of two objects at that path.
 * The wrapped component will receive the following props:
 *
 * - `ascending`: a boolean indicating whether the sort is ascending or not
 * - `descending`: a boolean indicating whether the sort is descending or not
 * - `sortPath`: a string indicating the current sort comparison path in dot notation
 * - `sort`: a function that can be used to sort an array of objects
 * - `setAscending`: a function for setting `ascending`
 * - `setDescending`: a function for setting `descending`
 * - `setSortPath`: a function for setting `sortPath`
 * - `setSortFunc`: a function for setting a custom [comparison function](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/sort#Description) that will be used in `sort`
 * 
 * `sortable` also exposes a `sortablePropTypes` object for these props.
 * 
 * _Note: `setSortPath()` will automatically reset `ascending` to `true` when the current path is changed.
 * Additionally, it will toggle `ascending` if the same path is selected twice in a row, 
 * unless `false` is passed as the second parameter._
 *
 * **Options**
 * 
 * `getSet` may be passed an options object containing the following keys:
 * - `initialAscending`: Whether the sort is initially ascending (default=`true`)
 * - `initialSortPath`: The initial `sortPath`
 * - `initialSortFunc`: The initial `sortFunc`
 * - `onChange`: A callback that will be fired whenever the sorting state is updated
 * - `disableReverse`: disables the automatic reversing of sorted items when the sort is descending
 * 
 * The wrapped component may also receive these options as props.
 *
 * @name sortable
 * @type Function
 * @param {object} options - Options for the HOC as specified above.
 * @returns {Function} - A HOC that can be used to wrap a component.
 *
 * @example
 *
 * function SortedPeopleList ({ people, sort, ascending, setAscending }) {
 *   return (
 *     <div>
 *       <ol>
 *         { 
 *           sort(people).map(person => 
 *             <li>`${ person.name } - ${ person.age }`</li>
 *           )
 *         }
 *       </ol>
 *       <button onClick={ () => setAscending(!ascending) }>
 *         Reverse order
 *       </button>
 *     </div>
 *   )
 * }
 * 
 * SortedPeopleList.propTypes = {
 *   ...sortablePropTypes,
 *   people: PropTypes.arrayOf(PropTypes.shape({
 *    name: PropTypes.string.isRequired,
 *    age: PropTypes.string.isRequired,
 *   })),
 * }
 *
 * export default compose(
 *    sortable({ 
 *      sortPath: 'age',
 *    }),
 * )(SortedPeopleList)
 *
*/
var omitUndefined = function omitUndefined(obj) {
  return (0, _utils.omitBy)(obj, _utils.isUndef);
};

function sortable() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (WrappedComponent) {
    var _class, _temp;

    return _temp = _class =
    /*#__PURE__*/
    function (_React$Component) {
      _inherits(Sortable, _React$Component);

      _createClass(Sortable, [{
        key: "config",

        /*
         * A friendly name for React devtools and errors
         */
        // Combine options with props
        get: function get() {
          return _objectSpread({}, options, {}, this.props);
        }
      }]);

      function Sortable(props) {
        var _this;

        _classCallCheck(this, Sortable);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(Sortable).call(this, props)); // Set initial state from config

        var _this$config = _this.config,
            _this$config$initialA = _this$config.initialAscending,
            initialAscending = _this$config$initialA === void 0 ? true : _this$config$initialA,
            initialSortPath = _this$config.initialSortPath,
            initialSortFunc = _this$config.initialSortFunc;
        _this.state = {
          ascending: initialAscending,
          sortPath: initialSortPath,
          sortFunc: initialSortFunc
        }; // Bind class methods

        _this.sort = _this.sort.bind(_assertThisInitialized(_this));
        _this.setAscending = _this.setAscending.bind(_assertThisInitialized(_this));

        _this.setDescending = function (val) {
          return _this.setAscending(!val);
        };

        _this.setSortFunc = _this.setSortFunc.bind(_assertThisInitialized(_this));
        _this.setSortPath = _this.setSortPath.bind(_assertThisInitialized(_this));
        return _this;
      }

      _createClass(Sortable, [{
        key: "componentDidUpdate",
        value: function componentDidUpdate(oldProps, oldState) {
          // Pass relevant props through to child
          if (!(0, _utils.isEqual)(oldProps, this.props)) {
            var _this$props = this.props,
                ascending = _this$props.ascending,
                sortPath = _this$props.sortPath,
                sortFunc = _this$props.sortFunc;
            return this.setState(omitUndefined({
              ascending: ascending,
              sortPath: sortPath,
              sortFunc: sortFunc
            }));
          } // Call onChange when sort state changes


          if ((0, _utils.isEqual)(oldState, this.state)) return;
          var onChange = this.config.onChange;
          if (onChange) return onChange(this.state);
        }
      }, {
        key: "setAscending",
        value: function setAscending(ascending) {
          this.setState({
            ascending: ascending
          });
        }
      }, {
        key: "setSortFunc",
        value: function setSortFunc(sortFunc) {
          this.setState({
            sortFunc: sortFunc
          });
        }
      }, {
        key: "setSortPath",
        value: function setSortPath(newPath) {
          var doToggle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
          // By default, toggles ascending if the path is already selected
          var _this$state = this.state,
              sortPath = _this$state.sortPath,
              ascending = _this$state.ascending;

          if (newPath === sortPath) {
            if (doToggle) ascending = !ascending;
          } else {
            // Default to ascending when switching paths
            ascending = true;
          }

          this.setState({
            sortPath: newPath,
            ascending: ascending
          });
        }
      }, {
        key: "sort",
        value: function sort(array) {
          var _this$state2 = this.state,
              ascending = _this$state2.ascending,
              sortFunc = _this$state2.sortFunc,
              sortPath = _this$state2.sortPath;
          var disableReverse = this.config.disableReverse; // Use custom sort if provided, otherwise default to orderBy()

          if (sortFunc) {
            var sorted = _toConsumableArray(array).sort(sortFunc);

            if (!ascending && !disableReverse) sorted.reverse();
            return sorted;
          } else {
            var order = ascending ? 'asc' : 'desc';

            var _sorted = (0, _utils.orderBy)(array, function (item) {
              return (0, _utils.get)(sortPath, item);
            }, order);

            return _sorted;
          }
        }
      }, {
        key: "render",
        value: function render() {
          var _this$state3 = this.state,
              ascending = _this$state3.ascending,
              sortPath = _this$state3.sortPath;
          return _react["default"].createElement(WrappedComponent, _objectSpread({
            ascending: ascending,
            descending: !ascending,
            sortPath: sortPath,
            sort: this.sort,
            setAscending: this.setAscending,
            setDescending: this.setDescending,
            setSortFunc: this.setSortFunc,
            setSortPath: this.setSortPath
          }, this.props));
        }
      }]);

      return Sortable;
    }(_react["default"].Component), _defineProperty(_class, "displayName", (0, _utils.wrapDisplayName)(WrappedComponent, 'sortable')), _temp;
  };
} // Proptypes for components wrapped by sortable


var sortablePropTypes = {
  ascending: _propTypes["default"].bool.isRequired,
  descending: _propTypes["default"].bool.isRequired,
  sortPath: _propTypes["default"].string.isRequired,
  sort: _propTypes["default"].func.isRequired,
  setAscending: _propTypes["default"].func.isRequired,
  setDescending: _propTypes["default"].func.isRequired,
  setSortPath: _propTypes["default"].func.isRequired,
  setSortFunc: _propTypes["default"].func.isRequired
};
exports.sortablePropTypes = sortablePropTypes;